import classNames from 'classnames'
import { InputNumber } from 'antd'
import styles from './Stepper.module.css'
import accurateCalc from 'accurate-core'

interface Props {
  value?: number
  onChange?: (n: number) => void
  step?: number
  digits?: number
  min?: number
  max?: number
  disabled?: boolean
  light?: boolean
  className?: string
}

export default function Stepper({
  value,
  onChange,
  step = 1,
  digits = 0,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER,
  disabled = false,
  light = false,
  className,
}: Props) {
  const minDisabled = (value || 0) - step < min
  const maxDisabled = (value || 0) + step > max
  const fillColor = light ? '#B1B5C3' : '#23262F'
  const iconColor = light ? '#141416' : '#FCFCFD'

  return (
    <div
      className={classNames(
        'flex items-center w-32 gap-4 select-none',
        styles.MyStepper,
        className
      )}
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <span
        className={classNames('stepper-btn w-8 h-8 block cursor-pointer', {
          'cursor-not-allowed': minDisabled,
        })}
        onClick={() => {
          if (minDisabled) {
            return
          }
          onChange?.(accurateCalc.subtract(value || 0, step))
        }}
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect width="32" height="32" rx="16" fill={fillColor} />
          <g opacity="0.88">
            <rect
              x="10.75"
              y="15.25"
              width="10.5"
              height="1.5"
              rx="0.75"
              fill={`${minDisabled ? '#777e90' : iconColor}`}
            />
          </g>
        </svg>
      </span>
      <InputNumber
        className={classNames('stepper-input')}
        onPressEnter={e => {
          e.preventDefault()
        }}
        disabled={disabled}
        min={min}
        max={max}
        value={value}
        onChange={val => {
          if (val! < min) {
            onChange?.(min)
          } else if (val! > max) {
            onChange?.(max)
          } else {
            onChange?.(Number(val?.toFixed(digits)))
          }
        }}
      />
      <span
        className={classNames('stepper-btn w-8 h-8 block cursor-pointer', {
          'cursor-not-allowed': maxDisabled,
        })}
        onClick={() => {
          if (maxDisabled) {
            return
          }

          onChange?.(accurateCalc.add(value || 0, step))
        }}
      >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <rect width="32" height="32" rx="16" fill={fillColor} />
          <g opacity="0.88">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.75 11.5C16.75 11.0858 16.4142 10.75 16 10.75C15.5858 10.75 15.25 11.0858 15.25 11.5V15.25H11.5C11.0858 15.25 10.75 15.5858 10.75 16C10.75 16.4142 11.0858 16.75 11.5 16.75H15.25V20.5C15.25 20.9142 15.5858 21.25 16 21.25C16.4142 21.25 16.75 20.9142 16.75 20.5V16.75H20.5C20.9142 16.75 21.25 16.4142 21.25 16C21.25 15.5858 20.9142 15.25 20.5 15.25H16.75V11.5Z"
              fill={`${maxDisabled ? '#777e90' : iconColor}`}
            />
          </g>
        </svg>
      </span>
    </div>
  )
}
